let currentId = 0

export const CycleUidMixin = {
  beforeCreate() {
    this._cycleUid = currentId++
  }
}
